import { Component, Input } from '@angular/core';
import { IContentSection } from '../../../../shared/interfaces/card-info.interface';
import { RevealDirective } from '../../../../shared/directives/reveal.directive';

@Component({
  selector: 'app-steps-section',
  imports: [RevealDirective],
  templateUrl: './steps-section.html',
  styleUrl: './steps-section.scss'
})
export class StepsSection {
  /** Supplies heading + lead copy + steps (kept in the data files so copy never drifts). */
  @Input({ required: true }) section!: IContentSection;

  /** Lead paragraphs minus the eyebrow line (the short lead that ends with a colon). */
  get bodyLead(): string[] {
    return (this.section.lead ?? []).filter((p) => !/:\s*$/.test(p.trim()));
  }

  /** Eyebrow above the cards — the data's colon-terminated lead line, or a sensible default. */
  get eyebrow(): string {
    return (this.section.lead ?? []).find((p) => /:\s*$/.test(p.trim())) ?? 'our process includes:';
  }
}
